import React from "react";

import { cn } from "@/lib/utils";
import { HeadingTag } from "@/utils/constants";
import IconArrowRight from "../Icons/IconArrowRight";
import IconFire from "../Icons/IconFire";
import { Link } from "@/i18n/routing";

interface SectionTitleProps {
  title: string;
  showButton?: boolean;
  showIcon?: boolean;
  icon?: React.ReactNode;
  buttonText?: string;
  buttonIcon?: React.ReactNode;
  buttonNavigation?: string;
  className?: string;
  headingClassName?: string;
  as?: HeadingTag;
  locale?: string;
}

const SectionTitle: React.FC<SectionTitleProps> = ({
  title,
  showButton = true,
  showIcon = true,
  icon = <IconFire />,
  buttonText = "See All",
  buttonIcon = <IconArrowRight />,
  buttonNavigation = "/",
  className,
  headingClassName,
  as: HeadingTag = "h2",
  locale,
}) => {
  const isRTL = locale === "ar";

  return (
    <div className={cn(className, "mb-8 flex items-center justify-between")}>
      <div className="flex items-center">
        {showIcon && <div className="transform transition-transform duration-300 hover:scale-110">{icon}</div>}
        <HeadingTag
          className={cn(headingClassName, "font-urbanist text-2xl font-semibold lg:text-3xl", isRTL ? "mr-2" : "ml-2")}
        >
          {title}
        </HeadingTag>
      </div>

      {showButton && (
        <div>
          <Link href={buttonNavigation}>
            <button className="inter group flex items-center rounded-2xl bg-white px-4 py-3 transition-all duration-300 ease-in-out active:scale-95 active:transform active:shadow-sm">
              <span
                className={cn(
                  "text-sm font-semibold text-black transition-colors duration-300 group-hover:text-primary",
                  isRTL ? "ml-2" : "mr-2",
                )}
              >
                {buttonText}
              </span>
              <div
                className={cn(
                  "transform transition-transform duration-300",
                  isRTL ? "rotate-180 group-hover:-translate-x-1" : "group-hover:translate-x-1",
                )}
              >
                {buttonIcon}
              </div>
            </button>
          </Link>
        </div>
      )}
    </div>
  );
};

export default SectionTitle;
